import { render, staticRenderFns } from "./SectionRenderer.vue?vue&type=template&id=4af230b9&scoped=true"
import script from "./SectionRenderer.vue?vue&type=script&lang=js"
export * from "./SectionRenderer.vue?vue&type=script&lang=js"
import style0 from "./SectionRenderer.vue?vue&type=style&index=0&id=4af230b9&lang=css"
import style1 from "./SectionRenderer.vue?vue&type=style&index=1&id=4af230b9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af230b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af230b9')) {
      api.createRecord('4af230b9', component.options)
    } else {
      api.reload('4af230b9', component.options)
    }
    module.hot.accept("./SectionRenderer.vue?vue&type=template&id=4af230b9&scoped=true", function () {
      api.rerender('4af230b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/footer-pages/components/SectionRenderer.vue"
export default component.exports